import React, { Fragment } from 'react';
import { GOOGLE_MAPS_LINK } from '@/constants';
import { styWrapper } from './styles';

function LocationSection() {
  return (
    <Fragment>
      <div id="fh5co-couple-story" className="fh5co-section-gray" css={styWrapper}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
              <h2 className="main-font">Lugar del evento</h2>
              <p className="sub-title">
                <a
                  href={GOOGLE_MAPS_LINK}
                  title="Click para ver el mapa en Google Maps"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: '#828282' }}
                >
                  <strong>Salón de Eventos La Floresta</strong>
                </a>{' '}
                <br />11 Calle 12-57, Zona 17, Lomas del Norte (carril auxiliar)
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15440.805776240277!2d-90.4624836!3d14.6445035!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8589a32d8e5d7fd1%3A0xd86db7d0c122d8c2!2sSal%C3%B3n%20de%20Eventos%20La%20Floresta!5e0!3m2!1ses!2sgt!4v1730682567429!5m2!1ses!2sgt"
                width="100%"
                height="450"
                frameBorder="0"
                style={{ border: '0' }}
                allowFullScreen
                aria-hidden="false"
                tabIndex="0"
                title="Google Maps - Scarlette & Waldemar Wedding"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default React.memo(LocationSection);
